/**
 * @link https://mui.com/material-ui/react-bottom-navigation/
 */

import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeBottomNav() {
  const [value, setValue] = React.useState(0);

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ width:'100%', backgroundColor:'background.header', p:1, mt:2, mb:5 }}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          sx={{ width:'60%' }}
        >
          <BottomNavigationAction label="Recents" icon={<RestoreIcon />} />
          <BottomNavigationAction label="Favorites" icon={<FavoriteIcon />} />
          <BottomNavigationAction label="Nearby" icon={<LocationOnIcon />} />
        </BottomNavigation>
      </Box>
      
      <ShowCode 
        codeString={`function BottomNavigationExample() {
  // State to track the active navigation item
  const [value, setValue] = React.useState(0);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', backgroundColor: 'background.header', p: 1 }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        sx={{ width: '60%' }}
      >
        <BottomNavigationAction label="Recents" icon={<RestoreIcon />} />
        <BottomNavigationAction label="Favorites" icon={<FavoriteIcon />} />
        <BottomNavigationAction label="Nearby" icon={<LocationOnIcon />} />
      </BottomNavigation>
    </Box>
  );
}`} 
        scope={{ 
          React, 
          Box, 
          BottomNavigation, 
          BottomNavigationAction, 
          RestoreIcon, 
          FavoriteIcon, 
          LocationOnIcon 
        }} 
      />
    </>
  );
}